import { Component, ViewChild } from '@angular/core';

import { NavController } from 'ionic-angular';

import { Entry } from '../shared/entry.model'

import { EntryList } from '../shared/entry-list.component'

import { WaldayuInfo } from '../../app/global'

import { WaldayuService } from '../../app/waldayu.service'

@Component({
  selector: 'page-bookmarks',
  templateUrl: 'bookmarks.html',
  // providers: [EntryList]
})
export class Bookmarks {
  // @ViewChild(EntryList) child: EntryList

  bookmarks: Entry[];
  edit: boolean = false;

  constructor(public navCtrl: NavController, public waldayuService: WaldayuService) {
   this.waldayuService.bookmarks.subscribe((bookmarks)=> { this.bookmarks = bookmarks });
  }

  removeEntries(bookmarks) {
    this.waldayuService.setBookmarks(bookmarks.filter(bookmark => !bookmark.checked))
    this.toggleEdit()
  }

  toggleEdit() {
    this.edit = !this.edit
  }

}



// WEBPACK FOOTER //
// ./src/pages/bookmarks/bookmarks.ts